import { Component, EventEmitter, Input, Output } from '@angular/core';
import { first } from 'rxjs/operators';
import { BaseComponent } from '../../../shared/base-components/base.component';
import { MotorCarrierFleetService } from '../../../irp/services/motor-carrier-fleet.service';
import { MotorCarrierService } from '../../../irp/services/motor-carrier.service';
import { MotorCarrierSupplementService } from '../../../irp/services/motor-carrier-supplement.service';
import { BusinessTransactionType } from '../../../foundation/models/enums/business-transaction-type.enum';

@Component({
    selector: 'irp-transaction-type',
    inputs: ['businessTransactionTypeId', 'businessTransactionParamId', 'businessTransactionParamTypeId'],
    outputs: ['onBusinessTransactionParamRemoved', 'onBusinessTransactionParamSelected', 'displayInformationalMessage'],
    templateUrl: './irp-transaction-type.html'
})

export class IRPTransactionTypeComponent extends BaseComponent {
    public dataLoaded = false;
    public businessTransactionTypeId: number;
    public businessTransactionParamTypeId: number;
    public businessTransactionParamId: number;
    public motorCarrierAccount: any;
    public onBusinessTransactionParamRemoved = new EventEmitter<any>();
    public onBusinessTransactionParamSelected = new EventEmitter<any>();
    public displayInformationalMessage = new EventEmitter<any>();
    public showIRPVehicleSearch = false;
    public businessTransactionType: BusinessTransactionType = new BusinessTransactionType();

    constructor(private motorCarrierFleetService: MotorCarrierFleetService, private motorCarrierAccountService: MotorCarrierService, private motorCarrierSupplementService: MotorCarrierSupplementService) {
        super();
    }

    public async ngOnInit() {
        if (this.businessTransactionParamTypeId === 31) {
            this.motorCarrierAccount = await this.motorCarrierFleetService.getMotorCarrierAccountByFleetId(this.businessTransactionParamId).pipe(first()).toPromise();
        } else if (this.businessTransactionParamTypeId === 30) {
            this.motorCarrierAccount = await this.motorCarrierAccountService.getMotorCarrierAccountSummary(this.businessTransactionParamId).pipe(first()).toPromise();
        }

        if (this.businessTransactionTypeId === this.businessTransactionType.MCAGrowUpTPA.id || this.businessTransactionTypeId === this.businessTransactionType.MCAVehicleMaintenance.id) {
            this.showIRPVehicleSearch = true;
        }

        if (this.motorCarrierAccount) {
            var fleetNumber: number;
            if (this.businessTransactionParamTypeId === 31) {
                fleetNumber = this.motorCarrierAccount['fleetNumber'];
            } else if (this.businessTransactionParamTypeId === 30) {
                fleetNumber = 0;
            }
            await this.motorCarrierSupplementService.hasMotorCarrierAccountOpenSupplements(this.motorCarrierAccount['motorCarrierAccountNumberId'], fleetNumber).subscribe(res => {

            }, error => {
                console.log(error);
                this.handleValidationResult(error);
                this.emitDisplayInformationalMessage(error.error.validationResults[0]['errorMessage']);
            });
        }
        this.dataLoaded = true;
    }

    public vehicleSelected = (vehicle): void => {

        const businessTransactionObject = { businessTransactionParamId: vehicle && vehicle.vehicleId, businessTransactionItemKeyTypeId: 2 };
        this.onBusinessTransactionParamSelected.emit(businessTransactionObject);
    };

    public vehicleRemoved() {
        this.onBusinessTransactionParamRemoved.emit();
    }

    public emitDisplayInformationalMessage(message) {
        this.displayInformationalMessage.emit(message);
    }
}
